import React from 'react';
import { MonthDayCell } from '../types/agenda.types';
import './MonthCalendarView.scss';

interface MonthCalendarViewProps {
  cells: MonthDayCell[];
  onDayClick?: (date: Date) => void;
}

const WEEKDAY_LABELS = ['lun', 'mar', 'mié', 'jue', 'vie', 'sáb', 'dom'];

const plural = (count: number, singular: string, pluralForm: string) => (count === 1 ? singular : pluralForm);

const MonthCalendarView: React.FC<MonthCalendarViewProps> = ({
  cells,
  onDayClick,
}) => {
  return (
    <div className="nv-card month-cal">
      <div className="month-cal__grid">
        {/* Header row */}
        {WEEKDAY_LABELS.map((d) => (
          <div key={d} className="month-cal__header">{d}</div>
        ))}
        {/* Day cells */}
        {cells.map((cell, idx) => {
          const interactive = cell.isCurrentMonth && !cell.isExclusion;
          const classes = ['month-cal__day'];
          if (!cell.isCurrentMonth) classes.push('month-cal__day--off');
          if (cell.isToday) classes.push('month-cal__day--today');
          if (cell.isExclusion) classes.push('month-cal__day--exclusion');
          if (interactive) classes.push('month-cal__day--interactive');
          const open = () => interactive && onDayClick?.(cell.date);
          return (
            <div
              key={idx}
              className={classes.join(' ')}
              onClick={open}
              role={interactive ? 'button' : undefined}
              tabIndex={interactive ? 0 : undefined}
              aria-current={cell.isToday ? 'date' : undefined}
              onKeyDown={(e) => {
                if (interactive && (e.key === 'Enter' || e.key === ' ')) {
                  e.preventDefault();
                  open();
                }
              }}
            >
              <span className="month-cal__day-number">{cell.dayNumber}</span>
              {interactive && (
                <div className="month-cal__chips">
                  <span className="month-cal__chip month-cal__chip--occupied">
                    {cell.occupied}
                    <span className="month-cal__chip-text"> {plural(cell.occupied, 'ocupado', 'ocupados')}</span>
                  </span>
                  <span className="month-cal__chip month-cal__chip--free">
                    {cell.free}
                    <span className="month-cal__chip-text"> {plural(cell.free, 'libre', 'libres')}</span>
                  </span>
                </div>
              )}
              {cell.isExclusion && (
                <div className="month-cal__chips">
                  <span className="month-cal__chip month-cal__chip--exclusion">Excluido</span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MonthCalendarView;
